import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { USER_INFO } from "../../../gql/user";
import { useCookies } from "react-cookie";
import { useRouter } from "next/router";

const Layout = ({ children }) => {
  const { error } = useQuery(USER_INFO);

  const [cookie, , removeCookie] = useCookies();
  const router = useRouter();

  if (
    cookie.access_token !== undefined &&
    error?.graphQLErrors.find((row) => row.message === "401: Unauthorized") !==
      undefined
  ) {
    removeCookie("access_token", {
      domain: process.env.REACT_APP_BASE_DOMAIN,
      path: "/",
    });
    setInterval(() => {
      window.open(`${process.env.REACT_APP_NEW_DOMAIN}login`, "_self");
    }, 500);
  }

  if (
    cookie.login_verif === "false_00" &&
    router.pathname !== "/myprofile/login-confirmation"
  ) {
    window.open(
      `${process.env.REACT_APP_DOMAIN}myprofile/login-confirmation`,
      "_self"
    );
  }

  return children;
};

export default Layout;
